export default __webpack_public_path__ + "static/media/acc1.3f083dbb.jpg";